/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

const DASHBOARD_BASE_LINK = '/admin/dashboard'

export function getDashboardLink () {
  return DASHBOARD_BASE_LINK
}
